import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { type RENIACUserData } from '@services/register/types'

type State = {
  document: {
    type: number
    number: string
  }
  userInfo: RENIACUserData | null
  lockInputs: boolean
}

const initialState: State = {
  document: {
    number: '',
    type: 1
  },
  userInfo: null,
  lockInputs: false
}

type Actions = {
  setDocument: (document: { type: number; number: string }) => void
  setUserInfo: (userInfo: RENIACUserData | null) => void
  setLockInputs: (value: boolean) => void
  resetState: () => void
}

const useRegisterStore = create(
  persist<State & Actions>(
    set => ({
      ...initialState,
      resetState: () => set(() => initialState),
      setDocument: document => set(() => ({ document })),
      setUserInfo: userInfo => set(() => ({ userInfo })),
      setLockInputs: value => set(() => ({ lockInputs: value }))
    }),
    {
      name: 'registerState',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

export default useRegisterStore
